import { useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import { Outlet, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { links, translations } from '../../../utils/staticContent';
import Footer from '../Footer';
import Header from '../Header';
import './style.scss';

type ValuePiece = Date | null;

type Value = ValuePiece | [ValuePiece, ValuePiece];

function AppLayout() {
    const [date, setDate] = useState<Value>(new Date());
    const [searchValue, setSearchValue] = useState('');
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();

    const searchPlaceholderURLMapper = {
        [links.events]: `${translations.find} ${translations.events2}`,
        [links.shows]: `${translations.find} ${translations.shows}`,
        [links.articles]: `${translations.find} ${translations.articles}`,
        [links.projects]: `${translations.find} ${translations.projects2}`,
    };

    const dateQuery = searchParams.get('date');
    const searchQuery = searchParams.get('search');

    useEffect(() => {
        if (!dateQuery) {
            setDate(new Date());
        }
    }, [dateQuery]);

    useEffect(() => {
        if (!searchQuery) {
            setSearchValue('');
        }
    }, [searchQuery]);

    function onDateChange(dateValue: Value) {
        setDate(dateValue);
        if (!Array.isArray(dateValue)) {
            navigate(`${links.events}?date=${dateValue?.getTime()}`);
        }
    }

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (searchValue.length) {
                setSearchParams({
                    search: searchValue,
                });
            } else {
                if (searchParams.has('search')) {
                    searchParams.delete('search');
                    setSearchParams(searchParams);
                }
            }
        }, 500);

        return () => clearTimeout(timeout);
    }, [searchValue]);

    const hideSideContent = location.pathname === links.about;
    const hideSearchBar = location.pathname === '/';

    return (
        <div
            className={`AppLayout ${hideSideContent ? 'hide-side-content' : ''} ${
                hideSearchBar ? 'hide-search' : ''
            }`}
        >
            <Header />
            <div className="app-body container">
                <div className="main-content">
                    <div className="side-container left-container">
                        <div className="search-container">
                            <input
                                className="search-input"
                                value={searchValue}
                                onChange={(e) => setSearchValue(e.target.value)}
                                placeholder={searchPlaceholderURLMapper[location.pathname]}
                            />
                            <img src="/search.svg" className="search-icon" alt="search" />
                        </div>
                    </div>
                    <main className="app-main">
                        <Outlet />
                    </main>
                    <div className="side-container right-container">
                        <Calendar
                            onChange={onDateChange}
                            value={date}
                            locale="sl"
                            minDetail="month"
                            tileClassName={`calendar-tile`}
                            next2Label={null}
                            prev2Label={null}
                            formatDay={(locale, date) => date.getDate().toString()}
                            navigationLabel={({ date, locale }) => {
                                return (
                                    <svg
                                        version="1.1"
                                        id="Layer_1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        x="0px"
                                        y="0px"
                                        width="154.666px"
                                        height="37.509px"
                                        viewBox="376.545 435.037 154.666 37.509"
                                    >
                                        <polygon
                                            fill="#C7B896"
                                            points="531.211,472.546 376.545,472.546 391.878,436.906 508.6,435.037 "
                                        />
                                        <text
                                            x="451"
                                            y="465"
                                            fill="#1a1a1a"
                                            textAnchor="middle"
                                            fontSize={20}
                                        >{`${date
                                            .toLocaleDateString(locale, { month: 'long' })
                                            .toUpperCase()}`}</text>
                                    </svg>
                                );
                            }}
                        />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default AppLayout;
